import { Button } from '@medly-components/core';
import { GEAR_ROUTE } from 'constants/routes';
import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { CANCER_MAPS, COMING_SOON, COMING_SOON_PARA1, COMING_SOON_PARA2, GO_TO_GEAR } from 'constants/map';
import MyMapInfo from '../MyMapInfo';

export const ComingSoon: FC = () => {
    const navigate = useNavigate();
    const submit = useCallback(() => {
        navigate(GEAR_ROUTE);
    }, [navigate]);

    return (
        <MyMapInfo
            title={`${CANCER_MAPS} ${COMING_SOON}`}
            description={
                <>
                    {COMING_SOON_PARA1} <br />
                    <br /> {COMING_SOON_PARA2}
                </>
            }
            action={<Button onClick={submit}>{GO_TO_GEAR}</Button>}
        />
    );
};

ComingSoon.displayName = 'ComingSoon';
